/**
 * @file HeaderCustomSlot.tsx
 *
 * @fileoverview This component can be used to render custom things below <header> part.
 */

export const HeaderCustomSlot = () => {
  return null;
};

export default HeaderCustomSlot;
